export default {
  paper: {
    minWidth: "340px"
  }
};
